export const FETCH_REGULAR_GIFT_CARDS = {
  START: 'GIFT_CARDS:FETCH_START',
  SUCCESS: 'GIFT_CARDS:FETCH_SUCCESS',
  ERROR: 'GIFT_CARDS:FETCH_ERROR',
};
export const FETCH_GIFT_CARD_TYPES = {
  START: 'GIFT_CARDS:FETCH_TYPES_START',
  SUCCESS: 'GIFT_CARDS:FETCH_TYPES_SUCCESS',
  ERROR: 'GIFT_CARDS:FETCH_TYPES_ERROR',
};
